<template>
  <div class="field-wrapper checkbox-field-wrapper">
    <v-checkbox class="checkbox-field" true-icon="mdi-check" false-icon="" hide-details
    :modelValue="modelValue" :readonly="isReadonly" @update:modelValue="$emit('update:modelValue', $event)"></v-checkbox>
    <label class="field-label checkbox-label">{{ title }}</label>
  </div>
</template>

<script>
export default {
  name: "CheckBoxField",
  emits: ["update:modelValue"],
  props: {
    title: String,
    modelValue: Boolean,
    isReadonly: Boolean
  }
};
</script>

<style lang="scss" scoped>
@use '../scss/control-field';
@use '../scss/checkbox-field';

.checkbox-field-wrapper {
  align-items: center;
}
.checkbox-label {
  margin-left: 7px;
}

.v-input--readonly :deep(.v-selection-control__input) {
  background-color: #eeeeee;
}
</style>